import { render } from "./App.vue?vue&type=template&id=12c34aba&ts=true"
import script from "./App.ts?vue&type=script&lang=ts"
export * from "./App.ts?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__